import React, { useState } from 'react'

import { TextField } from '@nike/eds'
import { Search } from '@nike/nike-design-system-icons'

type GlobalFilterProps = {
  globalFilter: string
  handleGlobalFilterChange: (value: string) => void
  placeholder?: string
  liveSearch?: boolean
}

export function GlobalFilter({ globalFilter, handleGlobalFilterChange, placeholder, liveSearch }: GlobalFilterProps) {
  const [inputValue, setInputValue] = useState(globalFilter || '');

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    setInputValue(value);

    if (liveSearch) {
      handleGlobalFilterChange(value);
    } else if (value === '') {
      handleGlobalFilterChange('');
    }
  };

  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (!liveSearch && e.key === 'Enter') {
      handleGlobalFilterChange(inputValue);
    }
  };

  React.useEffect(() => {
    if (globalFilter !== inputValue) {
      setInputValue(globalFilter || '');
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [globalFilter]);

  return (
    <TextField
      id='table--global-filter'
      className='base-table-global-search'
      type='search'
      label=''
      placeholder={placeholder || 'Search...'}
      beforeSlot={<Search />}
      value={inputValue}
      onChange={handleInputChange}
      onKeyDown={handleKeyDown}
      hideLabel
    />
  )
}
